(() => {
  const desktop = window.matchMedia('(min-width: 993px)');
  const initialize = (scope) => {
    scope.querySelectorAll('header-menu-tiles').forEach((menu, menuIndex) => {
      if (menu.dataset.izziMenuReady) return;
      menu.dataset.izziMenuReady = 'true';
      const branches = [...menu.querySelectorAll('.submenu-container')];
      const trigger = (branch) => branch.querySelector(':scope > a');
      const panel = (branch) => branch.querySelector(':scope > [class*="submenu-design__"], :scope > .megamenu-container');
      const close = (branch, dismissed = false) => {
        [branch, ...branch.querySelectorAll('.submenu-container')].forEach((item) => {
          item.classList.remove('izzi-menu-open');
          item.classList.toggle('izzi-menu-dismissed', dismissed);
          trigger(item)?.setAttribute('aria-expanded', 'false');
        });
      };
      const open = (branch) => {
        if (!desktop.matches) return;
        branch.parentElement.querySelectorAll(':scope > .submenu-container').forEach((sibling) => {
          if (sibling !== branch) close(sibling, true);
        });
        branch.classList.remove('izzi-menu-dismissed');
        branch.classList.add('izzi-menu-open');
        trigger(branch)?.setAttribute('aria-expanded', 'true');
      };
      branches.forEach((branch, index) => {
        const link = trigger(branch);
        const submenu = panel(branch);
        if (!link || !submenu) return;
        if (!submenu.id) submenu.id = `izzi-menu-${menuIndex}-${index}`;
        link.setAttribute('aria-controls', submenu.id);
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
        branch.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') open(branch);
        });
        branch.addEventListener('pointerleave', (event) => {
          if (branch.contains(event.relatedTarget)) return;
          if (!branch.contains(document.activeElement)) close(branch);
          else branch.classList.remove('izzi-menu-dismissed');
        });
        branch.addEventListener('focusin', () => open(branch));
        branch.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!branch.contains(document.activeElement) && !branch.matches(':hover')) close(branch);
          });
        });
      });
      menu.addEventListener('keydown', (event) => {
        if (!desktop.matches) return;
        const branch = event.target.closest('.submenu-container');
        if (!branch) return;
        const link = trigger(branch);
        if (event.key === 'Escape' || (event.key === 'ArrowLeft' && !branch.parentElement.classList.contains('tiles-menu'))) {
          event.preventDefault();
          event.stopPropagation();
          let closingBranch = branch;
          if (event.key === 'Escape') {
            while (closingBranch.parentElement.closest('.submenu-container')) closingBranch = closingBranch.parentElement.closest('.submenu-container');
          }
          trigger(closingBranch)?.focus();
          close(closingBranch, true);
        } else if (event.target === link && (event.key === 'ArrowDown' || event.key === 'ArrowRight')) {
          event.preventDefault();
          open(branch);
          panel(branch)?.querySelector('a[href], button')?.focus();
        }
      });
      document.addEventListener('pointerdown', (event) => {
        if (!menu.contains(event.target)) branches.forEach((branch) => close(branch, true));
      });
      desktop.addEventListener('change', () => branches.forEach((branch) => close(branch)));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
